import { styled } from '@/stitches.config';

import { ReactComponent as Poligon } from '@assets/icons/tooltip-poligon.svg';
import { Box } from '@base-app';

export const TooltipStyled = styled(Box, {
  alignItems: 'flex-start',
  backgroundColor: '$white',
  borderRadius: '$3',
  boxShadow: '$tooltip',
  color: '$darkBlue200',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '$2',
});

export const ColumnStyled = styled('span', {
  fontWeight: '$bold',
  marginLeft: '$1',
});

export const TooltipPoligon = styled(Poligon, {
  transform: 'translate(0, -5px)',
});

export const StyledChartTooltip = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
});
